var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5367 9.44879V47.2422H40.1576V9.44879H16.5367ZM14.1746 4.72461H42.5197C43.1461 4.72461 43.7469 4.97347 44.1899 5.41645C44.6329 5.85943 44.8818 6.46023 44.8818 7.0867V49.6043C44.8818 50.2308 44.6329 50.8316 44.1899 51.2746C43.7469 51.7175 43.1461 51.9664 42.5197 51.9664H14.1746C13.5481 51.9664 12.9473 51.7175 12.5043 51.2746C12.0614 50.8316 11.8125 50.2308 11.8125 49.6043V7.0867C11.8125 6.46023 12.0614 5.85943 12.5043 5.41645C12.9473 4.97347 13.5481 4.72461 14.1746 4.72461ZM28.3471 40.1559C28.9736 40.1559 29.5744 40.4048 30.0174 40.8478C30.4604 41.2908 30.7092 41.8916 30.7092 42.518C30.7092 43.1445 30.4604 43.7453 30.0174 44.1883C29.5744 44.6313 28.9736 44.8801 28.3471 44.8801C27.7207 44.8801 27.1199 44.6313 26.6769 44.1883C26.2339 43.7453 25.985 43.1445 25.985 42.518C25.985 41.8916 26.2339 41.2908 26.6769 40.8478C27.1199 40.4048 27.7207 40.1559 28.3471 40.1559Z",
    fill: "#0784C9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileD);
export default __webpack_public_path__ + "static/media/mobileD.15b341e2788f0e2867953b2d5a422225.svg";
export { ForwardRef as ReactComponent };